import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { ModelDeletedPayload } from './interfaces/model-deleted-payload.interface';
import { isNonNullObject } from 'utilities';

export const ModelDeletedMessage: MessageHandler<ModelDeletedPayload> = {
  send(payload: ModelDeletedPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.ModelDeleted, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is ModelDeletedPayload {
    return isNonNullObject(payload) && 'modelId' in payload && typeof payload.modelId === 'string';
  },
};
